import React, { CSSProperties } from 'react';

import { SingleAssignmentsInterface } from 'domain/services/teacher/dashboard/assignments/Index';

import TaksItem from './components/TaskItem/TaksItem';
import './Tasks.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  items?: Array<SingleAssignmentsInterface>;
  showAll?: boolean;
  status: 'overdue' | 'today' | 'tomorrow';
  overdue?: boolean;
  hideCompleted?: unknown;
}

const Tasks: React.FC<Props> = ({ style, status, items, showAll }) => {
  return (
    <div className="tasks-container" style={style}>
      {items &&
        items.length > 0 &&
        items.map((e, i) => (
          <TaksItem
            content={e}
            key={`${e.id}-${i}`}
            status={status}
            hideCompleted={true}
            showAll={showAll}
          />
        ))}
    </div>
  );
};

export default Tasks;
